const defaultResolution = window.devicePixelRatio

export default {
  TEXT_RESOLUTION: defaultResolution,
  VIEW_RESOLUTION: defaultResolution,
}
